import SideNav from './SideNav';

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/global/SideNav/index.js